'use strict';

const POLL_INTERVAL = 500;
const POLL_LIMIT = 15;
const CONSENT_CATEGORIES = ['preferences', 'statistics'];
const CONSENT_EVENTS = ['CookiebotOnConsentReady', 'CookiebotOnAccept'];

/**
 * Polls for the Purechat widget API and invokes the callback once it exists.
 * Gives up after POLL_LIMIT attempts so a blocked/declined widget does not poll forever.
 * @param {Function} callback - invoked once window.purechatApi is available
 */
function poll(callback) {
    let counter = 0;

    let interval = setInterval(() => {
        if (window.purechatApi) {
            clearInterval(interval);
            callback();
            return;
        }

        if (counter > POLL_LIMIT) {
            clearInterval(interval);
        }

        counter++;
    }, POLL_INTERVAL);
}

/**
 * Whether Cookiebot currently holds consent for every category Purechat is declared under.
 * Returns false when Cookiebot is not on the page, in which case the initial poll is the
 * only path - matching the pre-Cookiebot behaviour.
 * @returns {boolean} true when preferences and statistics are both consented
 */
function hasPurechatConsent() {
    if (!window.Cookiebot || !window.Cookiebot.consent) {
        return false;
    }

    return CONSENT_CATEGORIES.every((category) => window.Cookiebot.consent[category] === true);
}

/**
 * Runs the callback once - as soon as the Purechat widget API is available.
 *
 * Under Cookiebot the widget loader stays inert until the visitor consents to preferences and
 * statistics, which can happen long after the initial poll window has elapsed. Consent events
 * therefore restart the poll so late accepts still wire up the widget listeners.
 * @param {Function} callback - invoked at most once, with window.purechatApi available
 */
function onReady(callback) {
    let handled = false;

    let run = () => {
        if (handled) {
            return;
        }

        handled = true;
        callback();
    };

    poll(run);

    CONSENT_EVENTS.forEach((eventName) => {
        window.addEventListener(eventName, () => {
            if (!handled && hasPurechatConsent()) {
                poll(run);
            }
        });
    });
}

module.exports = {
    onReady: onReady
};
